var _style, _g, _g2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivatedKeys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "163.9px",
    height: "140px",
    viewBox: "0 0 163.9 140",
    style: {
      enableBackground: "new 0 0 163.9 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#989898;}\n\t.st1{fill:#B4B4B4;}\n\t.st2{fill:#818181;}\n\t.st3{fill:#979797;}\n\t.st4{fill:#5F5F5F;}\n\t.st5{fill:#B3B3B3;}\n\t.st6{fill:#A5A5A5;}\n\t.st7{fill:#909090;}\n\t.st8{fill:#525252;}\n\t.st9{fill:#7C7C7C;}\n\t.st10{fill:#A3A3A3;}\n\t.st11{fill:#A6A6A6;}\n\t.st12{fill:#3D3D3D;}\n\t.st13{fill:#565656;}\n\t.st14{fill:#5A5A5A;}\n\t.st15{fill:#BFBFBF;}\n\t.st16{fill:#A8A8A8;}\n\t.st17{fill:#686868;}\n\t.st18{fill:#969696;}\n\t.st19{fill:#626262;}\n\t.st20{fill:#6D6D6D;}\n\t.st21{fill:#494949;}\n\t.st22{fill:#939393;}\n\t.st23{fill:#BABABA;}\n\t.st24{fill:#707070;}\n\t.st25{opacity:0.2;fill:#010101;enable-background:new    ;}\n\t.st26{fill:#7A7A7A;}\n\t.st27{fill:#555555;}\n\t.st28{fill:#6F6F6F;}\n\t.st29{fill:#B2B2B2;}\n\t.st30{fill:#767676;}\n\t.st31{fill:#848484;}\n\t.st32{fill:#D1D1D1;}\n\t.st33{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st34{fill:#DD9619;}\n\t.st35{fill:#FCB01A;}\n\t.st36{fill:#6ABD45;}\n\t.st37{fill:#ED2224;}\n\t.st38{fill:#70CDDD;}\n\t.st39{fill:#F79421;}\n\t.st40{fill:#57A0D7;}\n\t.st41{fill:#3F4DA1;}\n\t.st42{fill:#F05223;}\n\t.st43{fill:#70B2E2;}\n\t.st44{fill:#8DC641;}\n\t.st45{fill:#2E368F;}\n\t.st46{fill:#C1282D;}\n\t.st47{fill:#D41C5C;}\n\t.st48{fill:#F9AA92;}\n\t.st49{fill:#C694C3;}\n\t.st50{fill:#3374BA;}\n\t.st51{fill:#7CB342;}\n\t.st52{fill:#616261;}\n\t.st53{fill:#E53A35;}\n\t.st54{fill:#5E4137;}\n\t.st55{fill:#F37046;}\n\t.st56{fill:#FBB03B;}\n\t.st57{fill:#9B51A0;}\n\t.st58{fill:#B9539F;}\n\t.st59{fill:#6D4D42;}\n\t.st60{fill:#5E6BB2;}\n\t.st61{fill:#F9A822;}\n\t.st62{fill:#8D6E63;}\n\t.st63{fill:#679F42;}\n\t.st64{fill:#FDD837;}\n\t.st65{fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.9,133.6 5.5,89.5 0,92.7 81.9,140 163.9,92.7 158.4,89.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.9,39L0,86.3l5.5,3.2l76.4,44.1l76.4-44.1l5.5-3.2L81.9,39z M81.9,130L6.4,86.3L82,42.6l75.6,43.7L81.9,130 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,92.7 0,86.3 81.9,133.6 81.9,140  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "81.9,133.6 163.9,86.3 163.9,92.7 81.9,140  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.4,86.3 81.9,42.7 157.5,86.3 155,87.9 81.9,45.4 8.3,87.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.9,45.4 8.3,87.9 81.9,130 155,87.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "69,51.4 69,66.1 81.7,73.4 81.7,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "56.4,44.1 56.4,58.7 69.1,66.1 69.1,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "43.7,36.7 43.7,51.4 56.4,58.7 56.4,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "31,29.4 31,44.1 43.7,51.4 43.7,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "69,66.1 69,80.8 81.7,88.1 81.7,73.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "56.4,58.7 56.4,73.4 69.1,80.8 69.1,66.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "43.7,51.4 43.7,66.1 56.4,73.4 56.4,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "31,44.1 31,58.7 43.7,66.1 43.7,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "69,80.8 69,95.4 81.7,102.8 81.7,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "56.4,73.4 56.4,88.1 69.1,95.4 69.1,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "43.7,66.1 43.7,80.8 56.4,88.1 56.4,73.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "31,58.7 31,73.4 43.7,80.8 43.7,66.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "69,95.4 69,110.1 81.7,117.5 81.7,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "56.4,88.1 56.4,102.8 69.1,110.1 69.1,95.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "43.7,80.8 43.7,95.4 56.4,102.8 56.4,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "31,73.4 31,88.1 43.7,95.4 43.7,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "94.4,51.4 94.4,66.1 81.7,73.4 81.7,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "94.4,66.1 94.4,80.8 81.7,88.1 81.7,73.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "94.4,80.8 94.4,95.4 81.7,102.8 81.7,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "94.4,95.4 94.4,110.1 81.7,117.5 81.7,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "107.1,44.1 107.1,58.7 94.4,66.1 94.4,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "107.1,58.7 107.1,73.4 94.4,80.8 94.4,66.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "107.1,73.4 107.1,88.1 94.4,95.4 94.4,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "107.1,88.1 107.1,102.8 94.4,110.1 94.4,95.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "119.8,36.7 119.8,51.4 107.1,58.7 107.1,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "119.8,51.4 119.8,66.1 107.1,73.4 107.1,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "119.8,66.1 119.8,80.8 107.1,88.1 107.1,73.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "119.8,80.8 119.8,95.4 107.1,102.8 107.1,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "132.6,29.4 132.6,44.1 119.8,51.4 119.8,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "132.6,44.1 132.6,58.7 119.8,66.1 119.8,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "132.6,58.7 132.6,73.4 119.8,80.8 119.8,66.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "132.6,73.4 132.6,88.1 119.8,95.4 119.8,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "31,29.4 43.5,22 56.3,29.4 43.7,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "43.7,36.7 56.3,29.4 69,36.7 56.4,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "56.5,44.1 69.1,36.7 81.8,44.1 69.2,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "69.3,51.4 81.9,44.1 94.6,51.4 82,58.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "43.7,22 56.3,14.7 69,22 56.4,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "56.5,29.4 69.1,22 81.8,29.4 69.2,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "69.3,36.7 81.9,29.4 94.6,36.7 82,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "82.1,44.1 94.7,36.7 107.4,44.1 94.8,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "56.5,14.7 69.1,7.3 81.8,14.7 69.2,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "69.3,22 81.9,14.7 94.6,22 82,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "82.1,29.4 94.7,22 107.4,29.4 94.8,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "94.8,36.7 107.4,29.4 120.1,36.7 107.6,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "69.3,7.3 81.9,0 94.6,7.3 82,14.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "82.1,14.7 94.7,7.3 107.4,14.7 94.8,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "94.8,22 107.4,14.7 120.1,22 107.6,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.6,29.4 120.2,22 132.9,29.4 120.3,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "94.4,51.4 94.4,66.1 81.7,73.4 81.7,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "94.4,66.1 94.4,80.8 81.7,88.1 81.7,73.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "94.4,80.8 94.4,95.4 81.7,102.8 81.7,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "94.4,95.4 94.4,110.1 81.7,117.5 81.7,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.1,44.1 107.1,58.7 94.4,66.1 94.4,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.1,58.7 107.1,73.4 94.4,80.8 94.4,66.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.1,73.4 107.1,88.1 94.4,95.4 94.4,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.1,88.1 107.1,102.8 94.4,110.1 94.4,95.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "119.8,51.4 119.8,66.1 107.1,73.4 107.1,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "119.8,66.1 119.8,80.8 107.1,88.1 107.1,73.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "119.8,80.8 119.8,95.4 107.1,102.8 107.1,88.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "132.6,44.1 132.6,58.7 119.8,66.1 119.8,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "132.6,58.7 132.6,73.4 119.8,80.8 119.8,66.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "132.6,73.4 132.6,88.1 119.8,95.4 119.8,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "31,29.4 43.5,22 56.3,29.4 43.7,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "43.7,36.7 56.3,29.4 69,36.7 56.4,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "56.5,44.1 69.1,36.7 81.8,44.1 69.2,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "69.3,51.4 81.9,44.1 94.6,51.4 82,58.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "43.7,22 56.3,14.7 69,22 56.4,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "56.5,29.4 69.1,22 81.8,29.4 69.2,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "82.1,44.1 94.7,36.7 107.4,44.1 94.8,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "69.3,22 81.9,14.7 94.6,22 82,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "94.8,36.7 107.4,29.4 120.1,36.7 107.6,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "69.3,7.3 81.9,0 94.6,7.3 82,14.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "82.1,14.7 94.7,7.3 107.4,14.7 94.8,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.6,29.4 120.2,22 132.9,29.4 120.3,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "69.3,36.7 81.9,29.4 94.6,36.7 82,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "56.5,14.7 69.1,7.3 81.8,14.7 69.2,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "82.1,29.4 94.7,22 107.4,29.4 94.8,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "94.8,22 107.4,14.7 120.1,22 107.6,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "31,29.4 43.5,22 56.3,29.4 43.7,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "43.7,36.7 56.3,29.4 69,36.7 56.4,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "56.5,44.1 69.1,36.7 81.8,44.1 69.2,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "69.3,51.4 81.9,44.1 94.6,51.4 82,58.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "43.7,22 56.3,14.7 69,22 56.4,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "56.5,29.4 69.1,22 81.8,29.4 69.2,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "82.1,44.1 94.7,36.7 107.4,44.1 94.8,51.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "69.3,22 81.9,14.7 94.6,22 82,29.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "94.8,36.7 107.4,29.4 120.1,36.7 107.6,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "69.3,7.3 81.9,0 94.6,7.3 82,14.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "82.1,14.7 94.7,7.3 107.4,14.7 94.8,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "107.6,29.4 120.2,22 132.9,29.4 120.3,36.7  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "82.1,44.1 94.7,36.7 107.4,44.1 94.8,51.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivatedKeys);
export default __webpack_public_path__ + "static/media/activated_keys.be65f7646a55443b4f4ece4f1c348371.svg";
export { ForwardRef as ReactComponent };